export const BootstrapBreakpoints = {
    xxs: "(max-width: 420px)",
    xs: "(min-width: 420px) and (max-width: 576px)",
    sm: "(min-width: 576px) and (max-width: 768px)",
    md: "(min-width: 768px) and (max-width: 992px)",
    lg: "(min-width: 992px) and (max-width: 1200px)",
    xl: "(min-width: 1200px) and (max-width: 1400px)",
    xxl: "(min-width: 1400px)"
};
